<template>
    <div
        class="redAngle"
        :class="{ 'clickable show-locator-modal': forceManualStoreSelection }"
        @click="forceManualStoreSelection && openLocatorModal()"
    >
        <div class="angleCorrect">
            <div class="locationContainer">
                <div
                    class="locPin clickable"
                    @click="openLocatorModal"
                >
                </div>

                <div
                    v-if="selectedStore"
                    class="containerText"
                >
                    <p :class="longStoreNameClass">
                        <strong>{{ storeName }}</strong>
                    </p>

                    <p :class="longAddressClass">
                        {{ addressLine }}
                    </p>

                    <a
                        v-if="selectedStore.phone"
                        @click.stop
                        :href="'tel:'+cleanPhone"
                    >
                        {{ selectedStore.phone }}
                    </a>
                    <p data-open="scheduleModal" class="appointment-in-nav">Request Appointment</p>
                </div>

                <div
                    v-else-if="forceManualStoreSelection"
                    class="containerText"
                >
                    <p><strong>Choose Location</strong></p>
                </div>

                <div v-else class="containerText">
                    <p>Loading...</p>
                </div>
            </div>

            <button
                type="button"
                class="button myStoreBt"
                :data-toggle="offCanvas"
            >
                <img
                    class="storeBt"
                    src="/wp-content/themes/ferg-framework/assets/images/ico_store.svg"
                    alt="Store Details"
                >
                <span>My Store</span>
            </button>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '~@styles/scss/base/variables';

strong {
    text-transform: uppercase;
}

.clickable {
    cursor: pointer;
}

.locationContainer {
    overflow: hidden;
    white-space: nowrap;
    display: flex;
    align-items: center;

    .locPin {
        content: url(/wp-content/themes/ferg-framework/assets/images/ico_pin.svg);
        padding-left: 1.65rem;
    }

    .containerText {
        padding-left: 0;
        margin-left: .8rem;
    }

	div {
		position: relative;
		margin-top: 0;
		margin-bottom: 0;
        font-size: 0.8em;

        p, a {
            margin-bottom: 0;
            line-height: 1.25;
        }

        a {
            color: #FFFFFF;
        }
	}
}

.middle-phone-container {
    display: none;
}
.appointment-in-nav {
    font-weight: 700; 
    cursor: pointer;
    &:hover {
        text-decoration: underline;
    }
}

@media only screen and (max-width: 1023px) {
    .redAngle {
        padding-top: 1rem;
        padding-bottom: 1rem;
    }

    .locationContainer {
        div {
            p, a {
                line-height: 1.5;
            }
        }

        .middle-phone-container {
            display: block;
            margin-left: 1.5rem;
        }

        i.phone-icon {
            display: none;
        }
    }
}

@media only screen and (max-width: 480px) {
    .locationContainer {
        i.phone-icon {
            display: block;
            font-size: 1.5rem;
        }

        .locPin {
            padding-left: 0;
            margin-left: .5rem;
        }
    }

    .myStoreBt {
        margin-right: .5rem;
    }
}

.long-name {
    letter-spacing: -0.02em;
    text-overflow: ellipsis;
    overflow: hidden;
    display: block;
    white-space: nowrap;

    @media only screen and (max-width: 420px) {
        width: 90%;
    }

    @media only screen and (min-width: 1023px) and (max-width: 1249px) {
        width: 60%;
    }

    @media only screen and (min-width: 1250px) and (max-width: 1470px) {
        width: 80%;
    }
}

</style>

<script>
import { createNamespacedHelpers } from 'vuex';

const {
    mapState,
    mapActions,
} = createNamespacedHelpers('location');

export default {
    computed: {
        ...mapState([
            'selectedStore',
            'forceManualStoreSelection',
            'browserGeoPending',
            'selectedStorePending'
        ]),

        storeName() {
            return this.selectedStore.txtLocationName ? this.selectedStore.txtLocationName : 'BEST-ONE';
        },

        addressLine() {
            return `${this.selectedStore.txtAddress}, ${this.selectedStore.txtCity}`;
        },

        offCanvas() {
            return this.forceManualStoreSelection ? 'null' : 'offCanvas';
        },

        cleanPhone() {
            return this.selectedStore.phone.replace(/[^0-9]/g, '');
        },

        longStoreNameClass() {
            return {
                'long-name': this.storeName.length > 39
            };
        },

        longAddressClass() {
            return {
                'long-name': this.addressLine.length > 39
            };
        },
    },

    mounted: function () {
        this.requireSelectedStore();
        this.checkStoreTimeOut();

        if (this.forceManualStoreSelection && !this.isLocationSettingPage()) {
            this.openLocatorModal();
        }

        if (this.selectedStore) {
            window.dataLayer = window.dataLayer || [];

            const analyticsData = {
                "event" : "pageload",
                "partner": {
                    "name": this.selectedStore.txtPartnerGroup,
                },
                "location": {
                    "name": this.selectedStore.txtLocationNickName ? this.selectedStore.txtLocationNickName : '',
                }
            };

            dataLayer.push(analyticsData);
        }
    },

    methods: {
        ...mapActions([
            'requireSelectedStore',
            'updateSelectedStore',
            'checkStoreTimeOut'
        ]),

        openLocatorModal() {
            console.log('opening through openLocatorModal');
            jQuery('#locatorModal').foundation('open');
        },

        isLocationSettingPage() {
            return window.location.href.indexOf('/store/') > -1;
        }
    },

    watch: {
        forceManualStoreSelection() {
            if (this.forceManualStoreSelection) {
                this.openLocatorModal();
            }
        }
    }
}
</script>
